module.exports = __webpack_public_path__ + "img/5.eb7431a3.jpg";